export enum MediaQueryTarget {
    Mobile = 'mobile',
    Phablet = 'phablet',
    Tablet = 'tablet',
    Desktop = 'desktop',
    Widescreen = 'widescreen',
    QuadHdY = 'quadHdY',
    Ultrawide = 'ultrawide',
    Landscape = 'landscape',
    PrefersReducedMotion = 'prefersReducedMotion',
    UsingMouse = 'usingMouse',
}

export interface MinRangeCondition<T = boolean> {
    [MediaQueryTarget.Phablet]: T;
    [MediaQueryTarget.Tablet]: T;
    [MediaQueryTarget.Desktop]: T;
    [MediaQueryTarget.Widescreen]: T;
    [MediaQueryTarget.QuadHdY]: T;
    [MediaQueryTarget.Ultrawide]: T;
}

export interface MaxRangeCondition<T = boolean> {
    [MediaQueryTarget.Mobile]: T;
}

export interface DiscreteCondition<T = boolean> {
    [MediaQueryTarget.Landscape]: T;
    [MediaQueryTarget.PrefersReducedMotion]: T;
    [MediaQueryTarget.UsingMouse]: T;
}

export interface MediaQueryScope<T = boolean>
    extends MinRangeCondition<T>,
        MaxRangeCondition<T>,
        DiscreteCondition<T> {}

export type MediaQueryConditions = Omit<MediaQueryScope<string>, MediaQueryTarget.Mobile>;

// TODO: Would prefer to utilize `MediaQueryTarget` + string value.
type FirstBreakpointTarget = 'mobile';
type LastBreakpointTarget = 'ultrawide';
type BetweenBreakpointsTarget = 'phablet' | 'tablet' | 'desktop' | 'widescreen' | 'quadHdY';

type BetweenBreakpointsFn = (
    min: FirstBreakpointTarget | BetweenBreakpointsTarget,
    max: BetweenBreakpointsTarget | LastBreakpointTarget,
) => boolean;

export interface MediaQueryContextDescriptor extends MediaQueryScope {
    betweenBreakpoints: BetweenBreakpointsFn;
}
